<template>
  <PresetsEditingBaseView
    :on-primary-button-pressed="onPrimaryButtonPressed"
    title="Add new preset"
    primary-button-text="Add"
    icon="mdi-plus"
    :profile-data="createProfileData"
    subtitle="Fill in the fields below to create a new preset"
    :request-loading="addLoading"
    :on-name-changed="onNameChanged"
    :on-lower-heating-value-changed="onLowerHeatingValueChanged"
    :on-mean-draft-changed="onMeanDraftChanged"
    :on-trim-changed="onTrimChanged"
    :on-true-wind-changed="onTrueWindChanged"
    :on-wind-direction-changed="onWindDirectionChanged"
    :on-speed-through-water-changed="onSpeedThroughWaterChanged"
    :on-fouling-changed="onFoulingChanged"
    :on-date-changed="onDateChanged"
    :show-success-snack-bar="showSuccessSnackBar"
    :show-error-snack-bar="showErrorSnackBar"
    :on-snack-bar-closed="onSnackBarClosed"
  />
</template>

<script>
import PresetsEditingBaseView from "./BaseView.vue";
import { KDProfileData } from "../../../domain/kdiagram/profiles/data";
import { mapActions, mapState } from "vuex";
export default {
  name: "PresetsEditingAddView",
  components: {
    PresetsEditingBaseView,
  },
  data() {
    return {
      presetData: KDProfileData.defaultData(),
      showSuccessSnackBar: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("kDiagram/profiles", ["selectedProfile"]),
    ...mapState("kDiagram/profiles/addProfile", [
      "createProfileData",
      "addLoading",
      "addError",
      "addSuccess",
      "addFailed",
    ]),
  },

  methods: {
    ...mapActions("kDiagram/profiles/addProfile", ["addProfile"]),
    async onPrimaryButtonPressed() {
      await this.addProfile({
        vesselName: this.$route.params.vessel,
        createProfileData: this.createProfileData,
      });
    },
    onNameChanged(value) {
      this._onAttributeChanged("profileName", value);
    },
    onLowerHeatingValueChanged(value) {
      this._onAttributeChanged("lhv", value);
    },
    onMeanDraftChanged(value) {
      this._onAttributeChanged("draft", value);
    },
    onTrimChanged(value) {
      this._onAttributeChanged("trim", value);
    },
    onTrueWindChanged(value) {
      this._onAttributeChanged("trueWind", value);
    },
    onWindDirectionChanged(value) {
      this._onAttributeChanged("windDirection", value);
    },
    onSpeedThroughWaterChanged(value) {
      this._onAttributeChanged("valuesList", value);
    },
    onFoulingChanged(value) {
      this._onAttributeChanged("fouling", value);
    },
    onDateChanged(dateRange) {
      this._onAttributeChanged("minDate", dateRange.minDate);
      this._onAttributeChanged("maxDate", dateRange.maxDate);
    },
    _onAttributeChanged(attribute, value) {
      this.$store.commit(
        "kDiagram/profiles/addProfile/SET_CREATE_PROFILE_DATA_ATTRIBUTE",
        {
          attribute: attribute,
          value: value,
        }
      );
    },
    onSnackBarClosed() {
      this.$store.commit("kDiagram/profiles/addProfile/RESTORE_REQUEST_STATE");
    },
  },
  watch: {
    addSuccess: {
      handler(newVal) {
        if (newVal != null) {
          this.showSuccessSnackBar = newVal;
        }
      },
    },
    addFailed: {
      handler(newVal) {
        if (newVal != null) {
          this.showErrorSnackBar = newVal;
        }
      },
    },
  },
};
</script>
